module.exports = __webpack_public_path__ + "static/media/scr_success.a4f3d74d.png";